export default {
  'transactionsList.title': 'List of transactions',
  'transactionsList.column.id': 'ID',
  'transactionsList.column.type': 'Type',
  'transactionsList.column.status': 'Status',
  'transactionsList.column.totalAmount': 'Total amount',

  'transactionsList.paymentsList.tab.all': 'All',
  'transactionsList.paymentsList.tab.pending': 'Pending',
  'transactionsList.paymentsList.tab.processed': 'Processed',
  'transactionsList.paymentsList.column.reference': 'Payment Reference',
  'transactionsList.paymentsList.column.settlementId': 'Settlement ID',
  'transactionsList.paymentsList.column.type': 'Payment Type',
  'transactionsList.paymentsList.column.method': 'Payment Option',
  'transactionsList.paymentsList.column.status': 'Status',
  'transactionsList.paymentsList.column.totalAmount': 'Total Amount',
};
